import { designTokens } from '@course-authoring/shared-types';
import type { QuestionnaireLifecycle } from '../api/questionnaireApi';

export interface QuestionnaireLifecycleBadgeProps {
  lifecycle: QuestionnaireLifecycle;
}

const LIFECYCLE_LABELS: Record<QuestionnaireLifecycle, string> = {
  draft: 'Draft',
  review: 'Review',
  publish: 'Published',
  close: 'Closed',
  retired: 'Retired',
};

// draft/publish/close reuse the same workflow-badge foreground colors as course/lesson badges
// (WorkflowStatusBadge.tsx); review/retired are ad hoc Tailwind hex — no designTokens equivalent yet.
const LIFECYCLE_COLORS: Record<QuestionnaireLifecycle, { color: string; backgroundColor: string }> = {
  draft: { color: designTokens.colors.workflowDraft, backgroundColor: '#fef3c7' }, // Amber-100
  review: { color: '#6d28d9', backgroundColor: '#ede9fe' }, // Violet-700 / Violet-100
  publish: { color: designTokens.colors.workflowPublished, backgroundColor: '#cffafe' }, // Cyan-100
  close: { color: designTokens.colors.workflowArchived, backgroundColor: '#f3f4f6' }, // Gray-100
  retired: { color: '#b91c1c', backgroundColor: '#fee2e2' }, // Red-700 / Red-100
};

export function QuestionnaireLifecycleBadge({ lifecycle }: QuestionnaireLifecycleBadgeProps) {
  const label = LIFECYCLE_LABELS[lifecycle];
  const { color, backgroundColor } = LIFECYCLE_COLORS[lifecycle];

  return (
    <span
      role="status"
      aria-label={`Questionnaire status: ${label}`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        padding: '4px 12px',
        borderRadius: '9999px',
        fontSize: '13px',
        fontWeight: 500,
        color,
        backgroundColor,
        border: `1px solid ${color}`,
      }}
    >
      <span
        aria-hidden="true"
        style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: color }}
      />
      {label}
    </span>
  );
}
